import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import type { ReleaseOption } from '../hooks/useReleaseOptions';
import { findMessages as messages } from './findMessages';

interface FindSongPickerProps {
  options: ReleaseOption[];
  value: string | null;
  onChange: (catalogItemUuid: string | null) => void;
}

/** The release that the fit is for (design outreach c1 head): the history and the fatigue answer per song. */
const FindSongPickerComponent: React.FC<FindSongPickerProps> = ({ options, value, onChange }) => {
  const intl = useIntl();
  const items = useMemo(
    () =>
      options.map((option) => (
        <option key={option.catalogItemUuid} value={option.catalogItemUuid}>
          {option.title}
        </option>
      )),
    [options]
  );
  return (
    <select
      className="form-select form-select-sm w-auto"
      aria-label={intl.formatMessage(messages.songLabel)}
      value={value ?? ''}
      onChange={(event) => onChange(event.target.value === '' ? null : event.target.value)}
      data-testid="find-song"
    >
      <option value="">{intl.formatMessage(messages.anySong)}</option>
      {items}
    </select>
  );
};

export const FindSongPicker = TypedMemo(FindSongPickerComponent);
